import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let AlertsInfoCheckmarkBoldIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.992 5.376 18.624.008 12 0zm6.927 8.2l-6.845 9.289c-.163.217-.407.359-.676.394-.268.035-.54-.039-.754-.206l-4.888-3.908c-.279-.223-.418-.578-.364-.932.054-.353.292-.65.625-.78s.71-.073.989.15l4.076 3.261 6.227-8.451c.204-.306.56-.476.927-.441.366.035.684.268.827.608.143.34.087.73-.144 1.016z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
AlertsInfoCheckmarkBoldIcon = __decorateClass([
  customElement("elm-alerts-info-checkmark-bold-icon")
], AlertsInfoCheckmarkBoldIcon);
export { AlertsInfoCheckmarkBoldIcon };
